import React, { Component } from 'react'
import classes from './TextArea.module.scss'
import PropTypes from 'prop-types'
import { InputError } from '@Root/HOCs'
import { delay } from 'redux-saga'
import { all } from '@Helpers/all'
import regularExpressions from '../../helpers/regularExpressions'

class TextArea extends Component {
	state = {}

	handleChange = (value) => {
		const { restriction, changeHandler } = this.props
		if (restriction) {
			const valueIsAllowed = (value, regularExpression) => {
				return value.match(regularExpression)
			}
			;(value === '' || valueIsAllowed(value, regularExpressions[restriction])) && changeHandler(value)
		} else {
			changeHandler(value)
		}
	}

	render() {
		const { value, isDisabled, placeholder, classNames, style, width, maxLength, error } = this.props
		const { handleChange } = this

		return (
			<InputError error={error} style={width ? { width } : null}>
				<textarea
					className={`${classes.TextArea} ${classNames ? classNames.reduce((acc, className) => acc + ` ${classes[className]}`, '') : ''}`}
					style={style}
					value={value}
					onChange={(e) =>
						all(
							() => handleChange(e.target.value),
							() => this.setState({ error: null })
						)
					}
					disabled={isDisabled}
					placeholder={placeholder}
					maxLength={maxLength || '5000'}
				/>
			</InputError>
		)
	}
}

TextArea.propTypes = {
	value: PropTypes.string,
	changeHandler: PropTypes.func,
	isDisabled: PropTypes.bool,
	placeholder: PropTypes.string,
	error: PropTypes.string,
	classNames: PropTypes.arrayOf(PropTypes.oneOf(['borderless', 'transparent', 'borderlessWhenDisabled'])),
	style: PropTypes.object,
	restriction: PropTypes.oneOf(['letters', 'lettersAndWhiteSpaces', 'digits', 'email']),
	width: PropTypes.string,
}

export default TextArea
